import { FolderOpenRounded } from '@mui/icons-material';
import { IconButton, InputAdornment, Tooltip } from '@mui/material';
import MuiTextField from '@mui/material/TextField';

import { Controller, ControllerRenderProps, FieldError, FieldValues, useFormContext } from 'react-hook-form';

interface IInputFileProps {
  name: string;
  label: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

export function InputFileRHF({ name, label, disabled }: IInputFileProps) {
  const { control, setError, clearErrors } = useFormContext();

  function getErrorMessage(error: FieldError) {
    let message = 'Campo obrigatório';

    if (error.message) {
      message = error.message;
    }

    return message;
  }

  async function handleSelectFolder(field: ControllerRenderProps<FieldValues, string>) {
    //@ts-expect-error
    const folder = await window.electronAPI.selectFolder();

    if (!folder) {
      setError(name, { type: 'required', message: 'Selecione um caminho válido' });
      return;
    }

    clearErrors();
    field.onChange(folder);
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={''}
      render={({ field, fieldState: { error } }) => (
        <MuiTextField
          {...field}
          label={error ? getErrorMessage(error) : label}
          error={Boolean(error)}
          disabled={disabled}
          fullWidth
          InputProps={{
            inputProps: {
              onClick: () => handleSelectFolder(field)
            },
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title="Selecionar pasta" arrow>
                  <IconButton onClick={() => handleSelectFolder(field)}>
                    <FolderOpenRounded />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            )
          }}
        />
      )}
    />
  );
}
